module.exports = "/static/assets/b97a035e41221b6fce72d74b9933f5b2.gif";